// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import VueScrollTo from 'vue-scrollto'
import VueTruncate from 'vue-truncate-filter'
import VueCarousel from 'vue-carousel'
import VueScrollactive from 'vue-scrollactive'
import * as VueGoogleMaps from 'vue2-google-maps'
import router from './router'
import store from './store'

if (!Object.entries)
  Object.entries = function( obj ){
    var ownProps = Object.keys( obj ),
    i = ownProps.length,
       resArray = new Array(i); // preallocate the Array

       while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
       return resArray;
     };

Vue.use(VueScrollTo)
Vue.use(VueCarousel)
Vue.use(VueScrollactive)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCeaNCIS6UBmuZd_a2EqyQMuf2bj3NrxlE'
  }
})
Vue.use(VueTruncate)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
